import { render, staticRenderFns } from "./OceanoDefaultItem.vue?vue&type=template&id=2cd593f5&scoped=true"
import script from "./OceanoDefaultItem.vue?vue&type=script&lang=ts"
export * from "./OceanoDefaultItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd593f5",
  null
  
)

export default component.exports